import Vue from 'vue';
import AppAuth from '@/AppAuth.vue';
import router from '@/router/auth';
import '@/directives/global';

import 'assets/css/style-auth.scss';
import store from '@/store';
import { checkAuthOrRedirect } from '@/utils/url-protect';
import '@/plugins/sentry.ts';
import '@/plugins/scripts.ts';

Vue.config.productionTip = false;

window.SEND_ACCEPT_VERSIONS = true;

checkAuthOrRedirect();

// Init scripts
import '@/services/FaviconService';

/* eslint-disable no-new */
const app = new Vue({
  render: (h) => h(AppAuth),
  router,
  store,
}).$mount('#app');

export default app;
